import { HTTP, route } from '@community_dev/requests'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/api'

interface LoginResponse extends Response {
  json(): Promise<{
    client_id: string
    device_id: string
    seat_id: string
    token: string
  }>
}

type MfaPostResponse = {
  clientId: string
  deviceId: string
  seatId: string
  token: string
}

type MfaPostRequest = {
  totp: string
  mfaToken: string
}

export function postLogin(auth: { email: string; password: string; client_id?: string }): Promise<LoginResponse> {
  return request(ENDPOINTS.AUTH.LOGIN, {
    body: auth,
    method: HTTP.POST,
    noAuth: true,
    rawResponse: true,
  })
}

export function deleteLogout(): Promise<any> {
  return request(ENDPOINTS.AUTH.LOGOUT, {
    method: HTTP.DELETE,
    skipAuthCheck: true,
    responseMethod: 'text',
  })
}

export function getCapabilities({
  clientId,
  seatId,
  token,
}: {
  clientId: string
  seatId: string
  token: string
}): Promise<string[]> {
  return request(route(ENDPOINTS.AUTH.CAPABILITIES, { clientId, seatId }), {
    method: HTTP.GET,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then(({ data }) => data)
}

export function postMfaCode({ totp, mfaToken }: MfaPostRequest): Promise<MfaPostResponse> {
  return request(ENDPOINTS.AUTH.MFA, {
    method: HTTP.POST,
    body: { totp },
    headers: {
      Authorization: `Bearer ${mfaToken}`,
    },
    skipAuthCheck: true,
  })
}
